var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('el-col',[_c('div',{staticClass:"grid-content bg-purple"},[_c('span',{staticClass:"spone_block"},[_vm._v("《中国企业家》杂志社")]),_vm._v(" "),_vm._l((_vm.data),function(vl){return _c('p',[_vm._v("\n                    "+_vm._s(vl['name'] + '  电话: '+vl['tel'])+" \n                ")])})],2)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4414d30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Bottom.vue
// module id = null
// module chunks = 